/* eslint max-len: 0 */
import React, { FC } from 'react';
import { SvgComponentProps } from './types';
import { Svg } from './Svg';

const ModApplications: FC<SvgComponentProps> = (props) => {
	return (
		<Svg {...props}>
			<path d='M11.8033 2.90995L14.4453 1.14895C15.1093 0.706951 16.0003 1.31395 16.0003 2.11295V11.113C16.0003 11.914 15.1053 12.51 14.4413 12.063L11.8143 10.293C10.6323 9.49595 9.4253 9.11295 8.0003 9.11295H7.0003V4.11295H8.0003C9.4143 4.11295 10.6283 3.69395 11.8033 2.90995Z' />
			<path d='M6 9.11285H4.5L6.718 13.5599C6.965 14.0539 6.765 14.6549 6.271 14.9019L6.06 15.0079C5.565 15.2549 4.965 15.0539 4.718 14.5599L2 9.11285H1C0.447 9.11285 0 8.66585 0 8.11285V5.11285C0 4.55985 0.447 4.11285 1 4.11285H6V9.11285Z' />
		</Svg>
	);
};

export { ModApplications };
